import React, { useEffect, useRef, useState } from "react";
import { Col, Icon, Modal, Row, Tag } from "antd";

import SearchControl from "../SearchControl";
import CollapseTitle from "./CollapseTitle";
import FilterGroupAccordion, { hasActiveValue, mergeUnnamedIntoFirst } from "../FilterGroupAccordion";
import SearchSubmitButton from "../../../SearchSubmitButton";
import getWidthContext from "../../../../HOCs/getWidthContext";
import styles from "./allSearchControls.scss";
import { ControlType, DataSource } from "../../../../models";

let cacheBodyStyle;

let bodyElement;

const AllSearchControls = props => {
  const {
    groupConfigs: rawGroupConfigs,
    form,
    numberOfControls,
    onSubmit,
    onReset,
    isMobile,
    showAllSearch,
    openAllSearchRef,
    activeFilterPills: unorderedPills
  } = props;
  const groupConfigs = mergeUnnamedIntoFirst(rawGroupConfigs);

  var pillOrderRef = useRef([]);
  var currentIds = (unorderedPills || []).map(function (p) { return p.id; });
  var ordered = pillOrderRef.current.filter(function (id) { return currentIds.includes(id); });
  (unorderedPills || []).forEach(function (p) {
    if (!ordered.includes(p.id)) {
      ordered.push(p.id);
    }
  });
  pillOrderRef.current = ordered;
  var activeFilterPills = ordered.map(function (id) {
    return unorderedPills.find(function (p) { return p.id === id; });
  });

  const [showAllControls, setShowAllControls] = useState(false);
  // Per-group user toggle state. undefined → fall back to auto (open if the
  // group has any active filter value); true/false → explicit user choice.
  const [explicitOpen, setExplicitOpen] = useState({});
  const brandNewCar = "brandNew";
  const vehiclesInWarranty = "vehiclesInWarranty";

  const noFiltersAnywhere = !groupConfigs.some(function (g) {
    return g && hasActiveValue(g.controls);
  });
  const getIsOpen = (index, controls) => {
    if (explicitOpen[index] !== undefined) return explicitOpen[index];
    if (hasActiveValue(controls)) return true;
    // When no filters are active across all groups, default-open the first
    // accordion so the user sees the primary controls immediately.
    if (index === 0 && noFiltersAnywhere) return true;
    return false;
  };
  const toggleGroup = (index, controls) => {
    setExplicitOpen({ ...explicitOpen, [index]: !getIsOpen(index, controls) });
  };
  // Find which group owns this field id; used to auto-expand the right
  // accordion when a user clicks an active-filter pill inside the modal.
  const findGroupIndexForField = (fieldId) => {
    if (!groupConfigs || !fieldId) return -1;
    for (var gi = 0; gi < groupConfigs.length; gi++) {
      var g = groupConfigs[gi];
      if (!g || !g.controls) continue;
      for (var ci = 0; ci < g.controls.length; ci++) {
        var c = g.controls[ci];
        if (c && (c.field === fieldId || c.id === fieldId)) return gi;
      }
    }
    return -1;
  };

  //  NOTE: this code is some kind of hack, i left this note if refactor caused some problems
  useEffect(() => {
    // Message from previous dev team
    // This code look not good, but it is a workaround to deal with antd Modal behaviour
    setTimeout(() => {
      bodyElement = document.getElementsByTagName("body").item(0);
      cacheBodyStyle = bodyElement.getAttribute("style");

      bodyElement.setAttribute("style", "");
    });
  }, []);

  const openAllSearch = () => {
    shouldScrollOnOpenRef.current = true;
    setShowAllControls(true);

    bodyElement.classList.add("modal-open");
    bodyElement.setAttribute("style", cacheBodyStyle);
  };

  useEffect(function () {
    if (openAllSearchRef) {
      openAllSearchRef.current = openAllSearch;
    }
  }, [openAllSearchRef]);

  const closeAllSearch = () => {
    setShowAllControls(false);

    bodyElement.classList.remove("modal-open");
    bodyElement.setAttribute("style", "");
  };

  const handleSubmit = () => {
    const { onSubmit } = props;

    onSubmit();
    closeAllSearch();
  };

  const returnColumnWidth = control => {
    // Inside the modal (showAllControls=true) we lay out a uniform 6-cell
    // grid. Range and MultiLevel each hold two sub-inputs (from/to or
    // parent/child) and therefore take two cells (span 8). Everything else
    // is one cell (span 4).
    if (showAllControls) {
      if (control.type == ControlType.range) return 8;
      if (control.type == ControlType.multiLevel) return 8;
      return 4;
    }

    if (control.dataSource == DataSource.make) return 10;
    if (control.type == ControlType.multiLevel) return 7;
    if (control.type == ControlType.range) return 7;
    if (control.type == ControlType.multiSelector) return 5;
    if (control.field == brandNewCar || control.field == vehiclesInWarranty) return 3;
    return 7;
  };

  const getPopupContainer = (trigger) => trigger.parentNode;

  var groupsRef = useRef(null);

  var handleLocalPillClick = function (fieldId, event) {
    // Scroll clicked tag to the left in horizontal tag list
    if (event && event.currentTarget && desktopTagsScrollRef.current) {
      var tag = event.currentTarget;
      var tagContainer = desktopTagsScrollRef.current;
      tagContainer.scrollTo({ left: tag.offsetLeft - tagContainer.offsetLeft, behavior: "smooth" });
    }

    // Force-open the accordion that owns this field so its DOM is mounted
    // before we try to find and scroll to the control.
    var targetGroupIndex = findGroupIndexForField(fieldId);
    if (targetGroupIndex >= 0) {
      setExplicitOpen(function (prev) {
        var next = Object.assign({}, prev);
        next[targetGroupIndex] = true;
        return next;
      });
    }

    // Defer the rest so React commits the open state and the children render.
    setTimeout(function () {
      // Search inside the modal's groups container to avoid matching sidebar duplicates
      var container = groupsRef.current || document;
      var el = container.querySelector('[data-field-id="' + fieldId + '"]');
      if (!el) return;

      var scrollContainer = groupsRef.current;
      runScrollAndFocus(el, scrollContainer);
    }, 0);
  };

  var runScrollAndFocus = function (el, scrollContainer) {
    if (scrollContainer) {
      var containerTop = scrollContainer.getBoundingClientRect().top;
      var elTop = el.getBoundingClientRect().top;
      var offset = elTop - containerTop + scrollContainer.scrollTop - (scrollContainer.clientHeight / 2) + (el.clientHeight / 2);
      scrollContainer.scrollTo({ top: offset, behavior: "smooth" });
    } else {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    // Highlight and focus after scroll finishes
    var scrollTimer = null;
    var onScrollStop = function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (scrollContainer) {
          scrollContainer.removeEventListener("scroll", onScrollStop);
        }
        // Focus
        var isCheckbox = el.querySelector('[class*="checkboxField"]') || el.classList.contains('checkboxField');
        if (!isCheckbox) {
          var focusable = el.querySelector('input, select, [tabindex], .ant-select');
          if (focusable) {
            focusable.click();
          }
        }
      }, 150);
    };

    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", onScrollStop);
    }
    setTimeout(onScrollStop, 150);
  };

  var desktopTagsScrollRef = useRef(null);
  var [dShowLeft, setDShowLeft] = useState(false);
  var [dShowRight, setDShowRight] = useState(false);

  var updateDesktopArrows = function () {
    var el = desktopTagsScrollRef.current;
    if (!el) return;
    setDShowLeft(el.scrollLeft > 0);
    setDShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
  };

  var scrollDesktopTags = function (dir) {
    var el = desktopTagsScrollRef.current;
    if (!el) return;
    el.scrollBy({ left: dir === "left" ? -120 : 120, behavior: "smooth" });
  };

  var prevPillCountRef = useRef(0);
  var shouldScrollOnOpenRef = useRef(false);

  var scrollDesktopTagsToEnd = function () {
    var el = desktopTagsScrollRef.current;
    if (el) {
      el.style.scrollBehavior = "auto";
      el.scrollLeft = el.scrollWidth;
      el.style.scrollBehavior = "";
      updateDesktopArrows();
    }
  };

  // Scroll to right when new pills are added while modal is open
  useEffect(function () {
    if (!showAllControls) { prevPillCountRef.current = 0; return; }
    var newCount = activeFilterPills ? activeFilterPills.length : 0;
    if (newCount > prevPillCountRef.current && prevPillCountRef.current > 0) {
      setTimeout(function () {
        var el = desktopTagsScrollRef.current;
        if (el) {
          el.scrollTo({ left: el.scrollWidth, behavior: "smooth" });
        }
        updateDesktopArrows();
      }, 100);
    }
    if (shouldScrollOnOpenRef.current) {
      shouldScrollOnOpenRef.current = false;
      setTimeout(scrollDesktopTagsToEnd, 100);
      setTimeout(scrollDesktopTagsToEnd, 300);
      setTimeout(scrollDesktopTagsToEnd, 600);
    }
    prevPillCountRef.current = newCount;
  }, [activeFilterPills.length, showAllControls]);

  return (
    <React.Fragment>
      {(showAllSearch && groupConfigs && groupConfigs.length > 1) && < CollapseTitle onClick={openAllSearch} />}
      <div className={styles.submitBtn}>
        <SearchSubmitButton onSubmit={handleSubmit} onReset={onReset} />
      </div>
      <Modal
        visible={showAllControls}
        width="100%"
        footer={null}
        mask={showAllControls}
        wrapClassName={!showAllControls ? styles.hideAllControls : ""}
        className={styles.allSearch}
        onCancel={closeAllSearch}
      >
        <div className={styles.title}>
          {`${"Filtriraj"}${numberOfControls !== null ? ` (${numberOfControls})` : ""
            }`}
          <SearchSubmitButton
            onSubmit={handleSubmit}
            onReset={onReset}
            className={styles.submit}
          />
        </div>
        {activeFilterPills && activeFilterPills.length > 0 && (
          <div>
            <div className={styles.activeFilterLabel}>Odabrani filtri:</div>
            <div className={styles.activeFilterTagsWrapper}>
            {dShowLeft && (
              <span className={styles.tagArrow} onClick={function () { scrollDesktopTags("left"); }}>
                <Icon type="left" />
              </span>
            )}
            <div className={styles.activeFilterTags} ref={desktopTagsScrollRef} onScroll={updateDesktopArrows}>
              {activeFilterPills.map(function (pill) {
                return (
                  <Tag
                    key={pill.id}
                    className={styles.activeFilterTag}
                    onClick={function (e) { handleLocalPillClick(pill.id, e); }}
                  >
                    <span>{pill.title}</span>
                  </Tag>
                );
              })}
            </div>
            {dShowRight && (
              <span className={styles.tagArrow} onClick={function () { scrollDesktopTags("right"); }}>
                <Icon type="right" />
              </span>
            )}
            </div>
          </div>
        )}
        <div className={styles.groups} ref={groupsRef}>
          {groupConfigs.map((groupConfig, index) => {
            const isOpen = getIsOpen(index, groupConfig.controls);
            const controlsRow = (
              <Row type="flex" gutter={12}>
                {groupConfig.controls.map((controlConfig, i) => {
                  return <Col
                    className={controlConfig.field == brandNewCar ? styles.clearBoth : styles.column}
                    span={returnColumnWidth(controlConfig)}
                    key={i}
                  >
                    <SearchControl
                      key={i}
                      form={form}
                      controlConfig={controlConfig}
                      isMobile={isMobile}
                      onSubmit={onSubmit}
                      showAllControls={true}
                      isSearch={true}
                      isColumn={false}
                      searchPage={true}
                      getPopupContainer={getPopupContainer}
                    />
                  </Col>
                })}
              </Row>
            );
            return (
              /* eslint-disable-next-line react/no-array-index-key */
              <div className={`${styles.group} ${index > 1 ? styles.columnCheckbox : ""}`} key={index}>
                <FilterGroupAccordion
                  name={groupConfig.name || "Osnovni podaci"}
                  isOpen={isOpen}
                  onToggle={() => toggleGroup(index, groupConfig.controls)}
                  titleClassName={styles.groupName}
                >
                  {controlsRow}
                </FilterGroupAccordion>
              </div>
            );
          })}
        </div>
      </Modal>
    </React.Fragment>
  );
};

AllSearchControls.defaultProps = {
  groupConfigs: [],
  numberOfControls: null,
  onSubmit: () => { },
  isMobile: false,
  showAllSearch: false,
};

export default getWidthContext(AllSearchControls);



// WEBPACK FOOTER //
// ./src/components/SearchControls/SearchGroups/AllSearchControls/index.tsx